exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.withdraw-protocol[data-v-2d94d1da] {\n  background-color: #fafafa;\n}\n.withdraw-protocol .navigate-item[data-v-2d94d1da] {\n  height: 1.466667rem;\n  line-height: 1.5;\n  margin-top: 0;\n  padding-left: 0.2rem;\n  padding-right: 0.226667rem;\n  border-bottom: 0.013333rem solid #EEEEEE;\n}", ""]);

// exports
